import {make} from "vuex-pathify";

const state = {
    users: [],
    managers: [],
    currentUserIndex: -1,
    page: 1,
    filters: {
        name: '',
        email: ''
    }
}

const mutations = {
    ...make.mutations(state),
}

const actions = {
    ...make.actions(state),
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
